import { QueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/react-query/constants';

// The comment families an ORDER_COMMENT_CREATED can change: order threads and badges,
// the services-order badges and the campaign chat. Media-plan, task and per-row task-unread
// queries are left alone, so a comment notification doesn't refetch a whole grid of dots.
const ORDER_COMMENT_FAMILIES = new Set<unknown>(['order', 'services-order', 'campaign']);

export const isOrderCommentNotificationType = (type: unknown): boolean =>
  type === 'ORDER_COMMENT_CREATED';

export const invalidateOrderCommentQueries = (queryClient: QueryClient): Promise<void> =>
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) =>
      queryKey[0] === queryKeys.comments && ORDER_COMMENT_FAMILIES.has(queryKey[1]),
  });
